<template>
  <b-modal-custom
    title="Vessels"
    :modal-class.sync="$options.data.themeClass"
    :visible="value"
    @change="$emit('input', $event)"
    @shown="modalShown = true"
    @hidden="modalShown = false"
    size="xl"
    :ok-only="true"
    ok-title="Close">

    <vessels-map
      :filter-values="filterValues"
      :required-filter-fields="requiredFilterFields"
      :modal-show="modalShown"
      :map-zoom="1"/>

  </b-modal-custom>
</template>

<script>
import BModalCustom from '@/base_components/BModalCustom'
import VesselsMap from '@/components/livestats/VesselsMap'

export default {
  name: 'vessels-map-modal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    requiredFilterFields: {
      type: Array,
      default: () => [],
    },

    filterValues: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    VesselsMap,
    BModalCustom,
  },

  data() {
    return {
      // this parameter is required to redraw map when modal dialog is displayed completely
      // b-modal has some animations which isn't finished but map is ready at the time,
      // it's needed to redraw map this case
      // (value doesn't help since modal content doesn't exist when modal is hidden)
      modalShown: false,
    };
  },

  methods: {
    // ...
  },

}
</script>

<style scoped>

</style>
